module.exports = __webpack_public_path__ + "static/media/5.6e778221.jpg";